///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.common = abcsetup.promos.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.common = {
    init: function () {
        // $(document).on('change', '#type', function (e) {
        //     // Hide and remove the required attr on type specific fields
        //     $('.promo_type_enable').hide();
        //     $('.promo_type_enable.required').find('input, select, textarea').attr('required', false);

        //     // Reset any browser validations that may have run
        //     window.fieldValidate.resetValidation($('.promo_type_enable.required').find('input, select, textarea'));

        //     if ($(this).val() != '') {
        //         // Show and re-apply the required attr on type specific fields
        //         $('.promo_type_enable.' + $(this).val()).show();
        //         $('.promo_type_enable.required.' + $(this).val()).find('input, select, textarea').attr('required', true);
        //     }
        // });

        // $('#type').trigger('change');

        // $('textarea.ckeditor').toArray().forEach(element => CKEDITOR.create(element, CKEDITOR.config));

        // //$('form.promo').show();
    },
}
